<div class="main-container">
  <p-toast></p-toast>
    <div [formGroup]="quotationForm" class="booking-form" *ngIf="quotationForm">
      <div class="description-box">
        <p class="global-title">
          Title
        </p>
        <input pInputText formControlName="description">
      </div>
      <div class="comment-box">
        <p class="global-title">
          Comments
        </p>
        <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
      </div>
      <div class="quotation-options-container">
        <div>
          <p class="global-title">
            Base currency
          </p>
          <p-dropdown [options]="currencies" optionLabel="isoCode" formControlName="baseCurrency">
          </p-dropdown>
        </div>
        <div>
          <p class="global-title">
            Second currency
          </p>
          <p-dropdown placeholder="--" [options]="currencies" optionLabel="isoCode"
            formControlName="secondCurrency"></p-dropdown>
        </div>
        <div>
          <p class="global-title">
            Quotation date
          </p>
          <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true"
            formControlName="quotationDate" dateFormat="dd/mm/yy"></p-calendar>
        </div>
        <div>
          <p class="global-title">
            Balance due date
          </p>
          <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true"
            formControlName="dueDate" dateFormat="dd/mm/yy"></p-calendar>
        </div>
        <div>
          <p class="global-title">
            Deposit(EUR)
          </p>
          <input pInputText formControlName="deposit">
        </div>
      </div>
      <table class="transaction-table">
        <tr class="first-table-row">
          <th>#</th>
          <th>Type</th>
          <th class="description-th">Remarks</th>
          <th>Price</th>
          <th class="currency-th">Currency</th>
          <!-- Base currency -->
          <th>{{quotationForm.get('baseCurrency')!.value.isoCode}}</th>
          <!-- Second currency -->
          <th *ngIf="quotationForm.get('secondCurrency')!.value">
            {{quotationForm.get('secondCurrency')!.value.isoCode}}</th>
        </tr>
        <tr class="no-record-tr" *ngIf="productFormArray.length==0">
            <td colspan="6">
                <div class="no-record-row">
                    <p class="no-record-message">
                      No record
                    </p>
                    <div class="icon-wrap" (click)="insertItem(0)">
                      <i class="pi pi-plus"></i>
                    </div>
                  </div>
            </td>
        </tr>
        <tr formArrayName="products"
          *ngFor="let product of productFormArray; let i = index"
          (mouseenter)="mouseover(i)" (mouseleave)="mouseout(i)">
          <td [formGroupName]="i">
            {{i + 1}}
          </td>
          <td [formGroupName]="i">
            <p-dropdown [options]="productTypes" formControlName="type" optionLabel="name">
              <ng-template pTemplate="item" let-item>
                {{item.label | titlecase}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{item.label | titlecase}}
              </ng-template>
            </p-dropdown>
          </td>
          <td [formGroupName]="i" class="description-container">
            <textarea [rows]="1" pInputTextarea formControlName="description" [autoResize]="true" id="description-input"></textarea>
          </td>
          <td [formGroupName]="i">
            <input pInputText formControlName="amount" id="amount-input">
          </td>
          <td [formGroupName]="i">
            <p-dropdown [style]="{'minWidth':'50px'}" [options]="currencies" formControlName="currency" optionLabel="isoCode"></p-dropdown>
          </td>
          <td>
            {{productPriceInCurrency[i]}}
          </td>
          <td *ngIf="quotationForm.get('secondCurrency')!.value">
            {{productPriceInSecondCurrency[i]}}
          </td>
          <td class="menu-head">
            <table class="hover-menu"
              [hidden]="isHidden(i)">
              <tr>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-caret-up" (click)="moveUp(i)"></i>
                  </div>
                </td>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-caret-down" (click)="moveDown(i)"></i>
                  </div>
                </td>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-plus-circle" (click)="insertItem(i)"></i>
                  </div>
                </td>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-times-circle" (click)="removeItem(i)"></i>
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <div class="price-includes-container">
        <div>
          <p class="global-title">
            Prices include
          </p>
          <!-- <ck-editor name="editor1" formControlName="priceIncludes" [config]="editorConfig" skin="moono-lisa" language="en" [fullPage]="false"></ck-editor> -->
        </div>
        <div>
          <p class="global-title">
            Prices do not includes
          </p>
          <!-- <ck-editor name="editor2" formControlName="priceNotIncludes" [config]="editorConfig" skin="moono-lisa" language="en" [fullPage]="false"></ck-editor> -->
        </div>
      </div>
      <div *ngIf="bookingService.booking.preConfirmation">
        <!-- Total({{bookingService.booking.preConfirmation!.baseCurrency.isoCode}}){{totalPriceInCurrency}} -->
        <div *ngIf="bookingService.booking.preConfirmation.secondCurrency">
          Total({{bookingService.booking.preConfirmation!.secondCurrency.isoCode}})
          <!-- {{totalPriceInSecondCurrency}} -->
        </div>
      </div>
    </div>
</div>
